import { useEffect, useState } from 'react';
export const useSticky = ({ ref, position }) => {
    const rootMargin = position === 'bottom' ? '0px 0px -1px 0px' : '-1px 0px 0px 0px';
    const [isSticky, setIsSticky] = useState(false);
    useEffect(() => {
        if (!ref.current) {
            return;
        }
        const observer = new IntersectionObserver(([event]) => setIsSticky(event.intersectionRatio < 1), { threshold: [1], rootMargin: rootMargin });
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);
    return isSticky;
};
